'use client';

import dynamic from 'next/dynamic';
import CaseStudies from '@/components/common/case-study-section';
import ClientTestimonials from '@/components/home/client-testimonials';
import MetaTags from '@/components/meta-tag/meta-tag';
import TechnologyFaq from '@/components/technologies/technology-faq';
import Blog from '@/components/home/blog';
import SupplyChainSoftwareDevelopment from '@/components/home/supply-chain-software-development';
import SupplyChainSoftwareImage from '@/components/home/supply-chain-software-image';
import SupplyChainChangingFast from '@/components/home/supply-chain-changing-fast';
import SupplyChainSoftwareDevServices from '@/components/home/supply-chain-softdev-service';
import AIEnabledSupplyChain from '@/components/technologies/aienabled-supply-services';
import ScmSoftwareDevelopment from '@/components/home/scm-software-development';
import SupplyChainCaseStudies from '@/components/home/supply-chain-case-studies';
import SupplyChainKeyFocus from '@/components/common/scm-key-focus';
import WhyChooseMoweb from '@/components/common/why-choose-moweb';
import SupplyChainManagementFAQ from '@/components/faqs/scm-faq';

const ContactInfo = dynamic(() => import('@/components/common/contact-info'));
const ContactForm = dynamic(() => import('@/components/common/contact-form'));
const TechHeroSupplyChain = dynamic(() => import('@/components/technologies/tech-hero-supply-chain'));

const Page = () => {
    return (
        <>
            <MetaTags />
            <TechHeroSupplyChain />
            <SupplyChainSoftwareDevelopment />
            <SupplyChainSoftwareImage />
            <SupplyChainChangingFast />
            <SupplyChainSoftwareDevServices />
            <AIEnabledSupplyChain />
            <ScmSoftwareDevelopment />
            <SupplyChainCaseStudies />
            <SupplyChainKeyFocus />
            <CaseStudies />
            <section className="">
                <ClientTestimonials />
            </section>
            <WhyChooseMoweb />
            <TechnologyFaq title="FAQs On Supply Chain Management" bg="bg-aiml">
                <SupplyChainManagementFAQ />
            </TechnologyFaq>
            <Blog />
            <div className="section bg-primary py-100 dark:text-light dark:bg-black">
                <div className="container lg:container md:mx-auto">
                    <div className="row grid md:grid-cols-12 lg:grid-cols-12">
                        <ContactForm />
                        <ContactInfo />
                    </div>
                </div>
            </div>
        </>
    );
};

export default Page;
